import React from 'react';
import clsx from 'clsx';
import type { DataTableProps } from '../../types/ui';

function DataTable<T>({
  columns,
  rows,
  rowKey,
  emptyState,
  caption,
}: DataTableProps<T>) {
  if (rows.length === 0 && emptyState) {
    return <>{emptyState}</>;
  }

  return (
    <div className='max-w-full overflow-x-auto'>
      <table className='min-w-full border-separate border-spacing-0 text-start'>
        {caption ? <caption className='sr-only'>{caption}</caption> : null}
        <thead>
          <tr>
            {columns.map(column => (
              <th
                key={column.key}
                scope='col'
                className={clsx(
                  'border-b border-secondary-200 bg-secondary-50 px-4 py-3 text-xs font-semibold text-secondary-500',
                  'dark:border-secondary-800 dark:bg-secondary-950 dark:text-secondary-400',
                  column.hideOnMobile && 'hidden sm:table-cell',
                  column.className
                )}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr
              key={rowKey(row)}
              className='transition-colors hover:bg-secondary-50/80 dark:hover:bg-secondary-800/60'
            >
              {columns.map(column => (
                <td
                  key={column.key}
                  className={clsx(
                    'border-b border-secondary-100 px-4 py-3 text-sm text-secondary-700 last:border-b-0',
                    'dark:border-secondary-800 dark:text-secondary-200',
                    column.hideOnMobile && 'hidden sm:table-cell',
                    column.className
                  )}
                >
                  {column.cell(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DataTable;
